<template>
  <div class="dashboard-panel print-break-inside-avoid">
    <h3 class="section-title mb-4">
      <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
      Risk Detection & Alerts
    </h3>
    <div class="overflow-x-auto">
      <table class="w-full text-sm text-left">
        <thead class="table-header">
          <tr>
            <th class="px-3 py-2">Development</th>
            <th class="px-3 py-2">Workstream</th>
            <th class="px-3 py-2">Owner</th>
            <th class="px-3 py-2">Risk</th>
            <th class="px-3 py-2">Status</th>
            <th class="px-3 py-2">Alert</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="risk in risks"
            :key="`${risk.development}-${risk.workstream}`"
            class="border-b border-gray-100 hover:bg-gray-50"
          >
            <td class="px-3 py-2 font-medium">{{ risk.development }}</td>
            <td class="px-3 py-2">{{ risk.workstream }}</td>
            <td class="px-3 py-2">{{ risk.owner || '-' }}</td>
            <td class="px-3 py-2">
              <span class="px-2 py-1 rounded text-xs font-semibold" :class="riskClass(risk.risk_level)">
                {{ risk.risk_level }}
              </span>
            </td>
            <td class="px-3 py-2">
              <span class="px-2 py-1 rounded text-xs font-semibold" :class="statusClass(risk.status)">
                {{ risk.status }}
              </span>
            </td>
            <td class="px-3 py-2">{{ risk.alert_type }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  risks: { type: Array, default: () => [] }
})

const riskClass = (level) => {
  switch (level) {
    case 'High': return 'bg-red-100 text-red-800'
    case 'Medium': return 'bg-yellow-100 text-yellow-800'
    default: return 'bg-green-100 text-green-800'
  }
}

const statusClass = (status) => {
  switch (status) {
    case 'Delayed': return 'bg-red-100 text-red-800'
    case 'At Risk': return 'bg-yellow-100 text-yellow-800'
    default: return 'bg-green-100 text-green-800'
  }
}
</script>
